<template>
  <div v-if="isMobile">
    <el-drawer
      title="优惠金额"
      :visible.sync="visible"
      @close="handleClose"
      direction="btt"
      :before-close="handleClose"
      custom-class="discount-drawer"
      append-to-body
    >
      <div class="popup-header">
        <div class="header-content">
          <div class="discount-type">
            <span>优惠合计</span>
            <span>￥{{ (initData.discount_amount || 0) | filterPrice }}</span>
          </div>
        </div>
      </div>

      <div class="discount-content">
        <div
          v-for="category in sortedDiscountData"
          :key="category.key"
          v-show="category.items && category.items.length > 0"
          class="discount-item"
        >
          <span class="item-title">{{ category.label }}</span>
          <div class="scroll-view">
            <div class="scroll-content">
              <div
                v-for="(item, index) in category.items"
                :key="item.rule_id || index"
                class="item-product"
              >
                <div
                  v-for="product in item.applied_skus"
                  :key="product.sku"
                  class="item"
                >
                  <img
                    :src="product.image"
                    class="order-product-item-cover-img"
                    alt=""
                    width="116"
                    height="116"
                  />
                  <span class="discount-des">{{
                    category.key === "originalSubtotalDesc"
                      ? "减￥" + item.description
                      : item.description
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="drawer-footer">
        <div class="button-group fixed-bottom-1 as-fix-btn">
          <div class="button-group-divider" @click="handleClose">确认</div>
        </div>
      </div>
    </el-drawer>
  </div>
  <div v-else>
    <el-dialog
      title="优惠金额"
      :visible.sync="visible"
      @close="handleClose"
      custom-class="discount-dialog"
      append-to-body
      width="600px"
      center
      top="0"
    >
      <div class="popup-header">
        <div class="header-content">
          <div class="discount-type">
            <span>优惠合计</span>
            <span>￥{{ (initData.discount_amount || 0) | filterPrice }}</span>
          </div>
        </div>
      </div>

      <div class="discount-content">
        <div
          v-for="category in sortedDiscountData"
          :key="category.key"
          v-show="category.items && category.items.length > 0"
          class="discount-item"
        >
          <span class="item-title">{{ category.label }}</span>
          <div class="scroll-view">
            <div class="scroll-content">
              <div
                v-for="(item, index) in category.items"
                :key="item.rule_id || index"
                class="item-product"
              >
                <div
                  v-for="product in item.applied_skus"
                  :key="product.sku"
                  class="item"
                >
                  <img
                    :src="product.image"
                    class="order-product-item-cover-img"
                    alt=""
                    width="116"
                    height="116"
                  />
                  <span class="discount-des">{{
                    category.key === "originalSubtotalDesc"
                      ? "减￥" + item.description
                      : item.description
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <div class="button-group fixed-bottom-1 as-fix-btn">
          <div class="button-group-divider" @click="handleClose">确认</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DiscountPopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 1024;
    },

    discountData() {
      let detailDiscount = [];
      if (this.initData?.detail_discount) {
        detailDiscount = {
          timeLimited: this.initData.detail_discount?.time_limited || [],
          firstOrder: this.initData.detail_discount?.first_order || [],
          specificCoupon: this.initData.detail_discount?.specific_coupon || [],
        };
      }
      let reOriginalSubtotalDesc = [];
      if (this.initData?.original_subtotal_desc?.length > 0) {
        reOriginalSubtotalDesc = this.initData.original_subtotal_desc.map(
          (item) => {
            return {
              sku: item.sku,
              qty: item.qty,
              original_price: item.original_price,
              md_price: item.md_price,
              md_discount: item.md_discount,
              description: item.md_discount_total,
              applied_skus: [{ sku: item.sku, image: item.image }],
            };
          }
        );
      }
      return {
        ...detailDiscount,
        originalSubtotalDesc: reOriginalSubtotalDesc,
      };
    },

    sortedDiscountData() {
      if (!this.discountData) return [];

      const categories = [
        {
          key: "firstOrder",
          label: "新客首单礼",
          items: this.discountData.firstOrder || [],
        },
        {
          key: "timeLimited",
          label: "限时优惠",
          items: this.discountData.timeLimited || [],
        },
        {
          key: "specificCoupon",
          label: "优惠券",
          items: this.discountData.specificCoupon || [],
        },
      ];

      // 排序 --- 单品直降 排第一
      // 最小的sort_order，如相等，则取规则id的最小值
      categories.sort((a, b) => {
        const aSortOrder = (a.items[0] && a.items[0].sort_order) || Infinity;
        const bSortOrder = (b.items[0] && b.items[0].sort_order) || Infinity;

        if (aSortOrder !== bSortOrder) {
          return aSortOrder - bSortOrder;
        }

        const aMinRuleId = Math.min(
          ...a.items.map((item) => item.rule_id || Infinity)
        );
        const bMinRuleId = Math.min(
          ...b.items.map((item) => item.rule_id || Infinity)
        );

        return aMinRuleId - bMinRuleId;
      });

      const filteredCategories = [
        {
          key: "originalSubtotalDesc",
          label: "单品直降",
          items: this.discountData.originalSubtotalDesc ?? [],
        },
        ...categories,
      ].filter((category) => category.items && category.items.length > 0);

      return filteredCategories;
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
// 样式部分保持不变
.el-drawer__header {
  color: #212322;
  padding: 20px 16px 16px 0;
  margin-bottom: 0;
  text-align: left;
}
.el-drawer__body > * {
  padding-right: 0;
}
.discount-drawer {
  min-height: max-content;
  padding-bottom: 20px;
  .el-drawer__close-btn {
    padding: 0 !important;
  }
  .item-title {
    font-size: 12px;
    text-align: left;
  }
}
.discount-drawer,
.discount-dialog {
  padding-left: 16px;
  box-sizing: border-box;
  color: #212322;

  .popup-header {
    position: sticky;
    padding-bottom: 10px;
    padding-right: 16px;

    .icon-close {
      position: absolute;
      right: 16px;
      top: 12px;
    }

    .am-title {
      margin-bottom: 16px;
    }

    .title-l {
      font-size: 14px;
      font-weight: 600;
    }

    .discount-type {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 0 12px;
      color: #212322;

      Text {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .header-content {
      position: relative;
    }
  }

  .discount-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 20px;

    .discount-item {
      display: flex;
      flex-direction: column;
      gap: 14px;

      .item-title {
        font-size: 12px;
      }
    }

    .scroll-content {
      display: flex;
      flex-direction: row;
      gap: 10px;
      overflow-x: auto;

      .item-product {
        display: flex;
        flex-direction: row;
        gap: 10px;

        .item {
          width: auto;
          padding: 8px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ccc;

          img {
            width: 58px;
            height: auto;
            display: block;
          }
        }

        .discount-des {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          text-align: center;
          font-size: 10px;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
        }
      }

      .item-product:last-child {
        margin-right: 16px;
      }
    }
  }

  .drawer-footer {
    padding-right: 16px;
    position: relative;
    padding-top: 12px;

    ::after {
      content: "";
      position: absolute;
      top: 0;
      left: -16px;
      width: calc(100% + 30px);
      border-top: 1px solid #d3d3d5;
    }
  }

  .as-fix-btn {
    padding: 10px 0;
    background: #7f0019;
    padding-right: 16px;
    color: #fff;
    text-align: center;

    .single-button {
      margin-top: 12px;
    }
  }
}
.discount-dialog {
  top: 50%;
  transform: translateY(-50%);

  .discount-type {
    font-size: 16px;
  }
  .el-icon-close {
    font-size: 22px;
    color: #212322 !important;
  }
  .dialog__headerbtn:hover .el-dialog__close {
    color: #212322 !important;
    font-size: 22px;
  }
  .as-fix-btn {
    width: 40%;
    margin: 0 auto;
  }
}
.el-dialog__header {
  text-align: center;
}
</style>
